import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Layout from "@/components/Layout";
import ThemedToaster from "@/components/ThemedToaster";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import HabitLibrary from "@/pages/HabitLibrary";
import CalendarPage from "@/pages/CalendarPage";
import Community from "@/pages/Community";
import Onboarding from "@/pages/Onboarding";
import Premium from "@/pages/Premium";
import Profile from "@/pages/Profile";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import AuthCallback from "@/pages/AuthCallback";
import { AppProvider } from "@/store/AppContext";
import { AuthProvider, useAuth } from "@/store/AuthContext";
import { ThemeProvider } from "@/store/ThemeContext";

function AppRouter() {
  const location = useLocation();
  const { user, loading } = useAuth();

  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  if (loading) return null;

  if (!user) {
    return (
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    );
  }

  // Force first-time onboarding
  const forceOnboarding = user.has_onboarded === false && location.pathname !== "/onboarding";
  if (forceOnboarding) return <Navigate to="/onboarding" replace />;

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Dashboard />} />
        <Route path="/library" element={<HabitLibrary />} />
        <Route path="/calendar" element={<CalendarPage />} />
        <Route path="/community" element={<Community />} />
        <Route path="/onboarding" element={<Onboarding />} />
        <Route path="/premium" element={<Premium />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <AuthProvider>
          <AppProvider>
            <BrowserRouter>
              <AppRouter />
            </BrowserRouter>
            <ThemedToaster />
          </AppProvider>
        </AuthProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
